import { Link } from '@tanstack/react-router';
import { ArrowRight, RouteOff } from 'lucide-react';
import { AppShell } from '../components/layout/AppShell';
import { Card, CardContent } from '@/components/ui/card';

export const RetiredRoutePage: React.FC = () => (
  <AppShell>
    <Card className="mx-auto mt-12 max-w-2xl border-dashed">
      <CardContent className="p-10 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-100 text-indigo-700 dark:bg-indigo-950 dark:text-indigo-300">
          <RouteOff className="h-7 w-7" />
        </div>
        <h1 className="mt-5 text-2xl font-bold">This portal page has been retired</h1>
        <p className="mx-auto mt-2 max-w-lg text-sm leading-6 text-muted-foreground">
          LogLimit now uses release-scoped transmission control and the v1 Logs Explorer. No compatibility data can be created or managed from this portal.
        </p>
        <Link to="/transmission-control" className="mt-6 inline-flex items-center gap-2 font-semibold text-indigo-700 hover:text-indigo-900 dark:text-indigo-300">
          Open Transmission Control <ArrowRight className="h-4 w-4" />
        </Link>
      </CardContent>
    </Card>
  </AppShell>
);
